import React from 'react';

import RejectField from '@features/supplier-onboarding/components/RejectField';

const ReadOnlyInput = ({ label, name, value, className, hideIcon = false, stepName }) => {
	return (
		<div className="form-group">
			{label && (
				<label className={`medium-14 gray_dark_01 ${className}`} htmlFor={name}>
					{label}
				</label>
			)}
			<input
				type="text"
				className="dissable"
				placeholder=""
				value={value || ''}
				disabled
				id={name}
				name={name}
				onChange={() => false}
			/>
			{!hideIcon && <RejectField name={name} stepName={stepName} />}
		</div>
	);
};

export default ReadOnlyInput;
